import { render, staticRenderFns } from "./EncuestaAdmin.vue?vue&type=template&id=493248e9"
import script from "./EncuestaAdmin.vue?vue&type=script&lang=js"
export * from "./EncuestaAdmin.vue?vue&type=script&lang=js"
import style0 from "./EncuestaAdmin.vue?vue&type=style&index=0&id=493248e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports